angular.module('createReferrals')
.controller('CreateReferralsController', ['$scope', '$state', '$stateParams', 'Notification', 'Auth', 'Referral', 'UnsavedChanges', 'Logger', 'ReferralHelper', 'User', 'Practice', 'ModalHandler',
    function ($scope, $state, $stateParams, Notification, Auth, Referral, UnsavedChanges, Logger, ReferralHelper, User, Practice, ModalHandler) {

        var auth = $scope.auth = Auth.get() || {};
        $scope.current_user = Auth.current_user;

        $scope.immediateUpdate = false;

        $scope.model = {referral: {notes_attributes: [], notes: []}, practice: {}};

        // if there is only one provider in this practice, assign that user's ID here
        // if there are multiple providers and current user is a doctor, assign current user ID here
        // otherwise don't assign anything (leave empty)
        User.getProviders({practice_id: $scope.auth.practice_id}, function(allProviders) {
            if (allProviders.length == 1) {
                $scope.model.referral.orig_provider_id = allProviders[0].id;
            } else if (allProviders.length > 1) {
                let providerIds = allProviders.map(function(p) {return p.id});
                if (providerIds.includes(auth.id)) {
                    $scope.model.referral.orig_provider_id = auth.id;
                }
            }
        });

        // populating addresses
        User.get({id: auth.id}, function(user) {
            $scope.providerLocations = user.addresses;
            if (user.addresses.length < 2) {
                $scope.disableLocations = true;
                $scope.model.referral.orig_provider_address_id = user.addresses[0].id;
            }
        });


        ReferralHelper.watchProviders($scope);

        if(typeof $stateParams.pid !== 'undefined') {
            Practice.getByPublicId({publicId: $stateParams.pid}, function(practice) {
                $scope.onPracticeSelected(practice);
            }, function (failure) {
                Notification.error(failure.data.message);
            });
        }

        $scope.saveTemplate = function (model) {

            $scope.form.$setDirty();

            if ($scope.form.$invalid) {
                return false;
            }

            ReferralHelper.prepareSubmit($scope, model.referral);
            var resultHandlers = {
                success: function (success) {
                    $scope.model.referral.id = success.id;
                    $scope.model.attachments = [];
                    $scope.model.referral.notes_attributes = [];
                    Notification.success('Template was saved successfully!');
                    ReferralHelper.uploadAttachments($scope, success.id, function(message){
                        UnsavedChanges.resetCbHaveUnsavedChanges(); // to make redirect
                        $state.go('reviewReferral', {referral_id: success.id, message: message}, {reload: true});
                    });
                }, failure: function (failure) {
                    Notification.error('An error occurred during referral template creation...');

                }};
            Referral.saveTemplate(model, resultHandlers.success, resultHandlers.failure);
        };

        $scope.createReferral = function (model) {

            $scope.form.$setDirty();

            if ($scope.form.$invalid) {
                return false;
            }

            var resultHandlers = {
                success: function (referral) {
                    Logger.debug('Sent referral #' + referral.id);
                    ReferralHelper.uploadAttachments($scope, referral.id, function(message){
                        UnsavedChanges.resetCbHaveUnsavedChanges(); // to make redirect
                        $state.go('viewReferral', {referral_id: referral.id, message: message, isNew: true});
                    });
                },
                failure: function (failure) {
                    Notification.error('An error occurred during referral creation...');
                }
            };
            ReferralHelper.prepareSubmit($scope, model.referral);
            Referral.save(model, resultHandlers.success, resultHandlers.failure);
        };

        ReferralHelper.trackUnsavedChanges($scope);

    }]);
